import React, { useState, useEffect } from "react";
import PropertyDetailWithImageWithoutTypesense from "./PropertyDetailWithImageWithoutTypesense";
import { getAllProperties } from "services";
import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
} from "@reusejs/react";
import RecentlyVisitedSliderComponent from "./RecentlyVisitedSliderComponent";

let sectionDetails = {
  title: "Recently Visited",
  description: "Begin from where you left and select your preferred property",
};

export default function RecentlyVisitedComponent() {
  const [propertiesData, setPropertiesData] = useState([]);
  const getProperties = async () => {
    const data: any = await getAllProperties({
      apiConfig: {
        includeRelations: ["city", "sub_asset_type", "bank", "images"],
        includeMutations: ["state", "asset"],
        includeFacets: false,
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [
        {
          attribute: "status",
          op: "eq",
          value: "active",
        },
      ],
    });
    setPropertiesData(data.data);
  };

  useEffect(() => {
    getProperties();
  }, []);

  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "bg-gray-50 overflow-hidden py-10 md:py-20",
        innerContainerStyles: "max-w-7xl mx-auto pl-4 sm:px-6 lg:px-8",
      }}
    >
      <Heading
        title={sectionDetails.title}
        description={sectionDetails.description}
      />
      <div className="hidden md:block">
        <RecentlyVisitedSliderComponent
          elements={
            propertiesData &&
            propertiesData.map((item: any, index) => (
              <PropertyDetailWithImageWithoutTypesense
                top={true}
                widthClass="w-64"
                width={256}
                height={160}
                marginClass="mr-8"
                onClick={() => console.log("Card action button clicked")}
                property={item}
                {...item}
                key={index}
              />
            ))
          }
        />
      </div>
      <div className="lg:hidden block mt-10 lg:space-y-0 grid gap-x-4 grid-flow-col overflow-y-scroll scrollbar-hide">
        {propertiesData &&
          propertiesData.map((item: any, index) => (
            <PropertyDetailWithImageWithoutTypesense
              top={true}
              widthClass="w-72"
              width={384}
              height={160}
              onClick={() => console.log("Card action button clicked")}
              property={item}
              {...item}
              key={index}
            />
          ))}
      </div>
    </SectionContainerBase>
  );
}

const Heading = (props: any) => {
  return (
    <IconTitleDescriptionActionCard
      title={props.title}
      description={props.description}
      itemTitleDescriptionCardBaseClasses={{
        titleWrapper: "text-left",
        titleStyles:
          "text-3xl font-extrabold text-gray-900 sm:text-3xl sm:leading-none sm:tracking-tight lg:text-4xl",
        descriptionWrapper: "text-left mt-4 ",
        descriptionStyles: "max-w-2xl text-base text-gray-500",
      }}
    />
  );
};
